import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useQuery } from '@tanstack/react-query';
function fetchAuth0User() {
  return _fetchAuth0User.apply(this, arguments);
}
function _fetchAuth0User() {
  _fetchAuth0User = _asyncToGenerator(function* () {
    var _data$user;
    var res = yield fetch('/api/auth/user');
    if (!res.ok) return null;
    var data = yield res.json();
    return (_data$user = data.user) !== null && _data$user !== void 0 ? _data$user : null;
  });
  return _fetchAuth0User.apply(this, arguments);
}
export function useAuth0User() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useQuery = useQuery({
      queryKey: ['auth0User'],
      queryFn: fetchAuth0User,
      enabled,
      staleTime: 5 * 60 * 1000,
      retry: 1
    }),
    user = _useQuery.data,
    isLoading = _useQuery.isLoading,
    error = _useQuery.error,
    _refetch = _useQuery.refetch;
  return {
    user: user !== null && user !== void 0 ? user : null,
    loading: isLoading,
    error: error,
    refetch: function () {
      var _refetch2 = _asyncToGenerator(function* () {
        yield _refetch();
      });
      function refetch() {
        return _refetch2.apply(this, arguments);
      }
      return refetch;
    }()
  };
}